<template>
  <div>
    <template v-if="list_item">
      <v-list-item v-if="loading">
        <v-list-item-content>
          <v-progress-linear indeterminate></v-progress-linear>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
          v-else-if="data && data.percent !== 'N/A'"
          v-on="$listeners"
          v-bind="$attrs"
          :style="{'background-color': colors[`${data.kMean}_DARK`]}"
      >
        <v-list-item-title  :class="colors[`${data.kMean}_TEXT`]">SDP: {{data.kColor}}</v-list-item-title>
      </v-list-item>
      <v-list-item
          v-else-if="data && data.percent === 'N/A'"
      >
        <v-list-item-title  >SDP: N/A</v-list-item-title>
      </v-list-item>
    </template>
    <template v-else>
      <v-btn v-if="loading" v-bind="$attrs" loading></v-btn>
      <v-btn v-else-if="data && data.percent !== 'N/A'" v-on="$listeners" :loading="loading" v-bind="$attrs" :class="colors[`${data.kMean}_TEXT`]" :color="colors[`${data.kMean}_DARK`]">
        SDP: {{data.kColor}}
      </v-btn>
      <v-btn v-else-if="data && data.percent === 'N/A'">SDP: N/A</v-btn>
    </template>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "SdpButton",
  props: {
    sample_id: {
      required: true,
    },
    list_item: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    loading: true,
    data: null,
    colors: {
      C_DARK: 'rgba(121, 81, 161, 1)',
      C_TEXT: 'white--text',
      L_DARK: 'rgba(236, 222, 19, 1)',
      L_TEXT: 'black--text',
      M_DARK: 'rgba(87, 129, 193, 1)',
      M_TEXT: 'white--text',
      P_DARK: 'rgba(27, 176, 102, 1)',
      P_TEXT: 'black--text',
      Y_DARK: 'rgba(238, 42, 44, 1)',
      Y_TEXT: 'white--text',
      T_DARK: 'rgba(248, 152, 29, 1)',
      T_TEXT: 'white--text',
    }
  }),
  mounted() {
    this.getData();
  },
  methods: {
    async getData(){
      this.loading = true;
      const query = await axios.get(`https://wa.conan.conflabs.com/api/CVKntq2Mip/graphing/meta/radar/${this.sample_id}/terpenes`);
      this.data = query.data;
      this.loading = false;
    },
  }
}
</script>

<style scoped>

</style>
